export function sleep(ms) {
    return new Promise(resolve => setTimeout(() => resolve(undefined), ms));
}
//# sourceMappingURL=Sleep.js.map